// AUTHENTICATION
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNIN_FAILURE = "SIGNIN_FAILURE";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const ACCEPT_CONTRACT_SUCCESS = "ACCEPT_CONTRACT_SUCCESS";
export const ACCEPT_CONTRACT_FAILURE = "ACCEPT_CONTRACT_FAILURE";

// PRODUCTS
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_FAILURE = "GET_PRODUCTS_FAILURE";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const SET_PRODUCT_SUCCESS = "SET_PRODUCT_SUCCESS";
export const SET_PRODUCT_FAILURE = "SET_PRODUCT_FAILURE";
export const PUT_PRODUCT_SUCCESS = "PUT_PRODUCT_SUCCESS";
export const PUT_PRODUCT_FAILURE = "PUT_PRODUCT_FAILURE";
export const PUT_PRODUCT_REQUEST = "PUT_PRODUCT_REQUEST";
export const CONSIDER_REVENUE_SUCCESS = "CONSIDER_REVENUE_ICMS_SUCCESS";
export const PRODUCTS_CLEAN = "PRODUCTS_CLEAN";

// PRODUCTS - PISCOFINS
export const GET_PISCOFINS_SUCCESS = "GET_PISCOFINS_SUCCESS";
export const GET_PISCOFINS_FAILURE = "GET_PISCOFINS_FAILURE";
export const GET_DIVERGENCE_PISCOFINS_SUCCESS =
  "GET_DIVERGENCE_PISCOFINS_SUCCESS";
export const GET_DIVERGENCE_PISCOFINS_FAILURE =
  "GET_DIVERGENCE_PISCOFINS_FAILURE";
export const CLASSIFY_PRODUCT_PISCOFINS_SUCCESS =
  "CLASSIFY_PRODUCT_PISCOFINS_SUCCESS";
export const CLASSIFY_SUGGESTION_PISCOFINS_SUCCESS =
  "CLASSIFY_SUGGESTION_PISCOFINS_SUCCESS";
export const CLASSIFY_SUGGESTION_PISCOFINS_FAILURE =
  "CLASSIFY_SUGGESTION_PISCOFINS_FAILURE";
export const PUT_CLASSIFY_PISCOFINS_SUCCESS = "PUT_CLASSIFY_PISCOFINS_SUCCESS";
export const DELETE_CLASSIFY_PISCOFINS_SUCCESS =
  "DELETE_CLASSIFY_PISCOFINS_SUCCESS";
export const GET_PERIOD_CLASSIFY_PISCOFINS_SUCCESS =
  "GET_PERIOD_CLASSIFY_PISCOFINS_SUCCESS";
export const PISCOFINS_CLEAN = "PISCOFINS_CLEAN";
export const PISCOFINS_CLEAR_COMPANY = "PISCOFINS_CLEAR_COMPANY";

// PRODUCTS - ICMS
export const GET_ICMS_SUCCESS = "GET_ICMS_SUCCESS";
export const GET_ICMS_FAILURE = "GET_ICMS_FAILURE";
export const GET_DIVERGENCE_ICMS_SUCCESS = "GET_DIVERGENCE_ICMS_SUCCESS";
export const GET_DIVERGENCE_ICMS_FAILURE = "GET_DIVERGENCE_ICMS_FAILURE";
export const CLASSIFY_PRODUCT_ICMS_SUCCESS = "CLASSIFY_PRODUCT_ICMS_SUCCESS";
export const CLASSIFY_SUGGESTION_ICMS_SUCCESS =
  "CLASSIFY_SUGGESTION_ICMS_SUCCESS";
export const CLASSIFY_SUGGESTION_ICMS_FAILURE =
  "CLASSIFY_SUGGESTION_ICMS_FAILURE";
export const PUT_CLASSIFY_ICMS_SUCCESS = "PUT_CLASSIFY_ICMS_SUCCESS";
export const DELETE_CLASSIFY_ICMS_SUCCESS = "DELETE_CLASSIFY_ICMS_SUCCESS";
export const GET_PERIOD_CLASSIFY_ICMS_SUCCESS =
  "GET_PERIOD_CLASSIFY_ICMS_SUCCESS";
export const ICMS_CLEAN = "ICMS_CLEAN";
export const ICMS_CLEAR_COMPANY = "ICMS_CLEAR_COMPANY";

// CFOP
export const GET_CFOP_SUCCESS = "GET_CFOP_SUCCESS";
export const GET_CFOP_FAILURE = "GET_CFOP_FAILURE";
export const GET_LIST_CFOP_SUCCESS = "GET_LIST_CFOP_SUCCESS";
export const GET_LIST_CFOP_FAILURE = "GET_LIST_CFOP_FAILURE";
export const PUT_CFOP_SUCCESS = "PUT_CFOP_SUCCESS";
export const PUT_CFOP_FAILURE = "PUT_CFOP_FAILURE";
export const CHANGE_RECIPE_CFOP_SUCCESS = "CHANGE_RECIPE_CFOP_SUCCESS";
export const CHANGE_RECIPE_CFOP_FAILURE = "CHANGE_RECIPE_CFOP_FAILURE";
export const CFOP_CLEAN = "CFOP_CLEAN";

// COMPANIES
export const GET_COMPANIES_SUCCESS = "GET_COMPANIES_SUCCESS";
export const GET_COMPANY_SUCCESS = "GET_COMPANY_SUCCESS";
export const SET_COMPANY_SUCCESS = "SET_COMPANY_SUCCESS";
export const PUT_COMPANY_SUCCESS = "PUT_COMPANY_SUCCESS";
export const COMPANIES_CLEAN = "COMPANIES_CLEAN";
export const SET_MESSAGE_MODAL_FAILURE = "SET_MESSAGE_MODAL_FAILURE";
export const MESSAGE_MODAL_CLEAN = "MESSAGE_MODAL_CLEAN";

// RESULT
export const GET_RESULTS_SUCCESS = "GET_RESULTS_SUCCESS";
export const GET_RESULTS_FAILURE = "GET_RESULTS_FAILURE";
export const GET_RESULT_SUCCESS = "GET_RESULT_SUCCESS";
export const DELETE_RESULT_SUCCESS = "DELETE_RESULT_SUCCESS";
export const DELETE_RESULT_FAILURE = "DELETE_RESULT_FAILURE";
export const GET_SEGREGATIONS_SUCCESS = "GET_SEGREGATIONS_SUCCESS";
export const GET_ANALYTICAL_PRODUCTS_REQUEST =
  "GET_ANALYTICAL_PRODUCTS_REQUEST";
export const GET_ANALYTICAL_PRODUCTS_SUCCESS =
  "GET_ANALYTICAL_PRODUCTS_SUCCESS";
export const DOWNLOAD_ANALYTICAL_PRODUCTS_SUCCESS =
  "DOWNLOAD_ANALYTICAL_PRODUCTS_SUCCESS";

export const GET_DEVOLUTION_PRODUCTS_REQUEST =
  "GET_DEVOLUTION_PRODUCTS_REQUEST";
export const GET_DEVOLUTION_PRODUCTS_SUCCESS =
  "GET_DEVOLUTION_PRODUCTS_SUCCESS";
export const DOWNLOAD_DEVOLUTION_PRODUCTS_SUCCESS =
  "DOWNLOAD_DEVOLUTION_PRODUCTS_SUCCESS";

export const BLOCK_COMPETENCE_SUCCESS = "BLOCK_COMPETENCE_SUCCESS";
export const BLOCK_COMPETENCE_FAILURE = "BLOCK_COMPETENCE_FAILURE";

export const ACCEPT_ROUDING_SUCCESS = "ACCEPT_ROUDING_SUCCESS";
export const ACCEPT_ROUDING_FAILURE = "ACCEPT_ROUDING_FAILURE";
export const ACCEPT_DIVERGENCE_SUCCESS = "ACCEPT_DIVERGENCE_SUCCESS";
export const ACCEPT_DIVERGENCE_FAILURE = "ACCEPT_DIVERGENCE_FAILURE";
export const SET_DISCOUNT_SUCCESS = "SET_DISCOUNT_SUCCESS";
export const SET_DISCOUNT_FAILURE = "SET_DISCOUNT_FAILURE";
export const SET_FREIGHT_SUCCESS = "SET_FREIGHT_SUCCESS";
export const SET_FREIGHT_FAILURE = "SET_FREIGHT_FAILURE";
export const SET_DEVOLUTION_SUCCESS = "SET_DEVOLUTION_SUCCESS";
export const SET_DEVOLUTION_FAILURE = "SET_DEVOLUTION_FAILURE";
export const ACCEPT_DUPLICATED_SUCCESS = "ACCEPT_DUPLICATED_SUCCESS";
export const REPROCESS_RESULT_SUCCESS = "SET_DEVOLUTION_SUCCESS";
export const REPROCESS_RESULT_FAILURE = "SET_DEVOLUTION_SUCCESS";
export const SOLVE_MOVEMENT_SUCCESS = "SOLVE_MOVEMENT_SUCCESS";
export const RESULTS_CLEAN = "RESULTS_CLEAN";
export const SET_ADDITION_SUCCESS = "SET_ADDITION_SUCCESS";
export const SET_ADDITION_FAILURE = "SET_ADDITION_FAILURE";
export const SET_OUTRAS_DESPESAS_SUCCESS = "SET_OUTRAS_DESPESAS_SUCCESS";
export const SET_OUTRAS_DESPESAS_FAILURE = "SET_OUTRAS_DESPESAS_FAILURE";

// RECOVERIES
export const GET_RECOVERIES_REQUEST = "GET_RECOVERIES_REQUEST";
export const GET_RECOVERIES_SUCCESS = "GET_RECOVERIES_SUCCESS";
export const GET_RECOVERIES_FAILURE = "GET_RECOVERIES_FAILURE";
export const DOWNLOAD_REPORT_REQUEST = "DOWNLOAD_REPORT_REQUEST";
export const DOWNLOAD_REPORT_SUCCESS = "DOWNLOAD_REPORT_SUCCESS";
export const DOWNLOAD_REPORT_FAILURE = "DOWNLOAD_REPORT_FAILURE";

// CONFIGURAR EMPRESA
export const GET_LIST_CONFIGURATION_SUCCESS = "GET_LIST_CONFIGURATION_SUCCESS";
export const GET_LIST_CONFIGURATION_FAILURE = "GET_LIST_CONFIGURATION_FAILURE";
export const GET_ITEM_CONFIGURATION_SUCCESS = "GET_ITEM_CONFIGURATION_SUCCESS";
export const GET_ITEM_CONFIGURATION_FAILURE = "GET_ITEM_CONFIGURATION_FAILURE";
export const PUT_CONFIGURATION_SUCCESS = "PUT_CONFIGURATION_SUCCESS";
export const CLEAN_CONFIGURATION = "CLEAN_CONFIGURATION";

// DOWNLOAD PLAN
export const DOWNLOAD_PLAN_SUCCESS = "DOWNLOAD_PLAN_SUCCESS";
export const DOWNLOAD_PLAN_FAILURE = "DOWNLOAD_PLAN_FAILURE";

// DOWNLOAD PLAN RESULTADOS
export const GET_REQUEST_RELATORIO_RESULTADO_PDF =
  "GET_REQUEST_RELATORIO_RESULTADO_PDF";
export const GET_REQUEST_RELATORIO_RESULTADO_EXCEL =
  "GET_REQUEST_RELATORIO_RESULTADO_EXCEL";
export const GET_REQUEST_RELATORIO_RESULTADO_PDF_FINISH =
  "GET_REQUEST_RELATORIO_RESULTADO_PDF_FINISH";
export const GET_REQUEST_RELATORIO_RESULTADO_EXCEL_FINISH =
  "GET_REQUEST_RELATORIO_RESULTADO_EXCEL_FINISH";
